import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Tabs } from 'components/shared/Tabs';
import { Loading } from 'components/shared/Loading';

import { LessonRatings } from '../LessonRatings';
import { LessonReports } from '../LessonReports';
import { StudentsReviews } from '../StudentsReviews';
import { StudentsUnsubscribeReasons } from '../StudentsUnsubscribeReasons';
import { Surveys } from '../Surveys';

import styles from './InboxSection.module.scss';

const InboxSection = ({
  isRootAdmin,
  loading,
  lessonsRatingsCount,
  lessonsReportsCount,
  studentReviewCount,
  unsibscribeReasonsCount,
  surveysCount,
}: {
  isRootAdmin: any;
  loading: any;
  lessonsRatingsCount: any;
  lessonsReportsCount: any;
  studentReviewCount: any;
  unsibscribeReasonsCount: any;
  surveysCount: any;
}) => (
  <div className={styles.section}>
    {loading ? (
      <Loading />
    ) : (
      <Tabs
        variant="count"
        className={styles.tabs}
        innerClassName={styles.inner}
        items={
          isRootAdmin
            ? [
                {
                  label: getTranslation(
                    'inbox_page.tabs_labels.lessons_reports',
                  ),
                  count: lessonsReportsCount,
                  content: <LessonReports />,
                },
                {
                  label: getTranslation(
                    'inbox_page.tabs_labels.lesson_ratings',
                  ),
                  count: lessonsRatingsCount,
                  content: <LessonRatings />,
                },
                {
                  label: getTranslation('inbox_page.tabs_labels.reviews'),
                  count: studentReviewCount,
                  content: <StudentsReviews />,
                },
                {
                  label: getTranslation(
                    'inbox_page.tabs_labels.unsubscribe_reasons',
                  ),
                  count: unsibscribeReasonsCount,
                  content: <StudentsUnsubscribeReasons />,
                },
                {
                  label: 'Surveys',
                  count: surveysCount,
                  content: <Surveys />,
                },
              ]
            : [
                {
                  label: getTranslation(
                    'inbox_page.tabs_labels.lessons_reports',
                  ),
                  count: lessonsReportsCount,
                  content: <LessonReports />,
                },
                {
                  label: getTranslation(
                    'inbox_page.tabs_labels.lesson_ratings',
                  ),
                  count: lessonsRatingsCount,
                  content: <LessonRatings />,
                },
              ]
        }
      />
    )}
  </div>
);

export default InboxSection;
